import Layout from '@/layout'

const retntionRouter = {
  path: "/retention/list",
  redirect:'/retention/list',
  name:'retentionIndexList',
  hiddeChilden:true,
  hidden:false,
  meta: { 
    title: 'menu.retention', 
    iconClass: 'el-icon-files', 
    module:'retention', 
    roles:['RESERVE_USER','RESERVE_ADMIN', 'RESERVE_OBSERVER']
  },
  // meta: { title: 'menu.retention', iconClass: 'el-icon-files', module:'retention', roles:['EMPLOYEE','USER']},
  component: Layout,
  children:[
    {
      path: "/retention/list",
      name: "retentionList",
      hidden:true,
      component: () => import( "@/views/retention"),
      meta: { 
        title: 'menu.retention', 
        iconClass: 'el-icon-files', 
        module:'retention', 
        keepAlive: true, 
        roles:['RESERVE_USER','RESERVE_ADMIN', 'RESERVE_OBSERVER']
        // blackLists: ['zwj002','00714','bq001','nq001','nq002','00713', '00711' ]
      }
    },
    {
      path: "/retention/detail",
      name: "retentionDetail",
      hidden:true,
      component: () => import( "@/views/retention/detail"),
      meta: { 
        title: 'menu.retention', 
        iconClass: 'el-icon-files', 
        module:'retention', 
        roles:['RESERVE_USER','RESERVE_ADMIN', 'RESERVE_OBSERVER']
      }
    },
    {
      path: "/retention/add",
      name: "retentionAdd",
      hidden:true,
      component: () => import( "@/views/retention/retentionAdd"),
      meta: { 
        title: 'menu.retentionAdd', 
        iconClass: 'el-icon-download', 
        module:'retention', 
        keepAlive: false ,
        roles:['RESERVE_USER','RESERVE_ADMIN']
      }
      // 'PARTNER' 经销商角色
    },
  ]
}

export default retntionRouter